export default __webpack_public_path__ + "static/media/remote-track.f049575d.svg";